import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-758e8e02"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "求職者一覧", -1))
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "apply" }
const _hoisted_4 = { class: "horizontal" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "プロフィール", -1))
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_n_skeleton = _resolveComponent("n-skeleton")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_Student = _resolveComponent("Student", true)!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_empty = _resolveComponent("n-empty")!
  const _component_n_layout = _resolveComponent("n-layout")!

  return (_openBlock(), _createBlock(_component_n_space, {
    vertical: "",
    style: {"padding":"10px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_layout, { style: {"padding":"10px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_Menu),
          _hoisted_1,
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_n_space, {
                key: 0,
                vertical: "",
                style: {"background-color":"white","padding":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_skeleton, {
                    height: "1rem",
                    width: "33%"
                  }),
                  _createVNode(_component_n_skeleton, {
                    height: "1rem",
                    width: "66%",
                    sharp: false
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.students.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.students, (a) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: a.id
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("p", _hoisted_5, _toDisplayString(a.name), 1)
                      ]),
                      _createElementVNode("details", null, [
                        _hoisted_6,
                        _createVNode(_component_Student, {
                          data: a,
                          details: true
                        }, null, 8, ["data"])
                      ])
                    ]),
                    _createVNode(_component_n_divider, { class: "noMargin" })
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_n_empty, { description: "登録された求職者はいません" })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}